/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
import { createEnumKeyMap } from "../helpers/enum";
/**
 * @ignore
 * @internal
 */
export var _wellKnownSymbolMap = /*#__PURE__*/ createEnumKeyMap({
    asyncIterator: 0 /* WellKnownSymbols.asyncIterator */,
    hasInstance: 1 /* WellKnownSymbols.hasInstance */,
    isConcatSpreadable: 2 /* WellKnownSymbols.isConcatSpreadable */,
    iterator: 3 /* WellKnownSymbols.iterator */,
    match: 4 /* WellKnownSymbols.match */,
    matchAll: 5 /* WellKnownSymbols.matchAll */,
    replace: 6 /* WellKnownSymbols.replace */,
    search: 7 /* WellKnownSymbols.search */,
    species: 8 /* WellKnownSymbols.species */,
    split: 9 /* WellKnownSymbols.split */,
    toPrimitive: 10 /* WellKnownSymbols.toPrimitive */,
    toStringTag: 11 /* WellKnownSymbols.toStringTag */,
    unscopables: 12 /* WellKnownSymbols.unscopables */
});
//# sourceMappingURL=well_known.js.map